__turbopack_context__.v({
  "active": "style-module-scss-module__Kshwfa__active",
  "agent-search": "style-module-scss-module__Kshwfa__agent-search",
  "auth": "style-module-scss-module__Kshwfa__auth",
  "bar": "style-module-scss-module__Kshwfa__bar",
  "bar-container": "style-module-scss-module__Kshwfa__bar-container",
  "component": "style-module-scss-module__Kshwfa__component",
  "country-flag": "style-module-scss-module__Kshwfa__country-flag",
  "dropdown-arrow-icon": "style-module-scss-module__Kshwfa__dropdown-arrow-icon",
  "find-your-home": "style-module-scss-module__Kshwfa__find-your-home",
  "full-screen-search": "style-module-scss-module__Kshwfa__full-screen-search",
  "home": "style-module-scss-module__Kshwfa__home",
  "layout-container": "style-module-scss-module__Kshwfa__layout-container",
  "logo": "style-module-scss-module__Kshwfa__logo",
  "logo-wrapper": "style-module-scss-module__Kshwfa__logo-wrapper",
  "menu": "style-module-scss-module__Kshwfa__menu",
  "navigation": "style-module-scss-module__Kshwfa__navigation",
  "no-background-color": "style-module-scss-module__Kshwfa__no-background-color",
  "panel": "style-module-scss-module__Kshwfa__panel",
  "scrolled": "style-module-scss-module__Kshwfa__scrolled",
  "search": "style-module-scss-module__Kshwfa__search",
  "switcher": "style-module-scss-module__Kshwfa__switcher",
  "user": "style-module-scss-module__Kshwfa__user",
  "x": "style-module-scss-module__Kshwfa__x",
});
